import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faInstagram, faTiktok } from "@fortawesome/free-brands-svg-icons";

function Footer() {
  return (
    <footer className="footer-main">
      <div className="footer-container">
        {/* About Us Section */}
        <div className="footer-section footer-about">
          <h3 className="footer-heading">Ardency Construction & Trading Sdn. Bhd. 201701013881(1228046-W)</h3>
          <p className="footer-text">
            Ardency Construction & Trading Sdn. Bhd. is a trusted
            distributor of building materials within the construction industry
            in Malaysia. We supply a wide range of materials for construction, home
            building and remodelling purposes.
          </p>
          <h4 className="footer-subheading">Follow Us</h4>
          <div className="footer-social">
            <a
              href="https://www.facebook.com/p/Ardency-Construction-and-Trading-Sdn-Bhd-100049133691033/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faFacebook}
                className="footer-fb-icon"
              />
            </a>
            <a
              href="https://www.instagram.com/ardency_construction/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faInstagram}
                className="footer-ig-icon"
              />
            </a>
            <a
              href="https://www.tiktok.com/@ardency_construction"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faTiktok}
                className="footer-tiktok-icon"
              />
            </a>
            <a
              href="https://www.xiaohongshu.com/user/profile/65fce81b000000000600f0f6"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="footer-xhs-icon">
                <img
                  src="./xhs.svg"
                  style={{ width: '24px', height: '24px' }}
                  alt="XiaoHongShu"
                />
              </span>
            </a>
            <a
              href="https://s.lemon8-app.com/al/GghbQwUFUe"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="footer-xhs-icon">
                <img
                  src="./lemon8.svg"
                  style={{ width: '24px', height: '24px' }}
                  alt="lemon8"
                />
              </span>
            </a>
          </div>
        </div>

        {/* Contact Us Section */}
        <div className="footer-section footer-contact">
          <h3 className="footer-heading">Contact Us</h3>
          <p className="footer-contact-item">
            <span className="footer-contact-icon">
              <FontAwesomeIcon icon={faPhone} />
            </span>
            <span className="footer-contact-text-phone">
              <a href={`https://wa.me/+60124825199`} className="footer-phone-link" target="_blank"> 012-482 5199</a> /
              <a href={`https://wa.me/+60179765688`} className="footer-phone-link" target="_blank"> 017-976 5688</a> /
              <a href={`https://wa.me/+60175327288`} className="footer-phone-link" target="_blank"> 017-532 7288</a> /
              <a href={`https://wa.me/+60126308368`} className="footer-phone-link" target="_blank"> 012-630 8368</a>
            </span>
          </p>
          <p className="footer-contact-item">
            <span className="footer-contact-icon">
              <FontAwesomeIcon icon={faEnvelope} />
            </span>
            <span className="footer-contact-text-email">emarketing@ardency.com.my</span>
          </p>
          <p className="footer-contact-item">
            <span className="footer-contact-icon">
              <FontAwesomeIcon icon={faLocationDot} style={{ marginLeft: '4px' }} />
            </span>
            <span className="footer-contact-text-address">
              No.21, Jalan Wawasan 2C/KU7, Sungai Kapar Indah, 42200 Kapar,
              Selangor.
            </span>
          </p>
          <p className="footer-contact-item">
            <span className="footer-contact-icon">
              <FontAwesomeIcon icon={faClock} />
            </span>
            <span className="footer-contact-text-businesshours">
              Business Hours: Monday - Friday | 9am - 6pm
            </span>
          </p>
        </div>

        {/* Location Section */}
        <div className="footer-section footer-map">
          <h3 className="footer-heading">Location</h3>
          <iframe
            className="footer-map-frame"
            src="https://maps.google.com/maps?q=Ardency Construction and Trading Sdn. Bhd., 21, Jalan Wawasan 2C/KU 7 Sungai Kapar Indah Kapar, 42200 Klang, Selangor&t=&z=13&ie=UTF8&iwloc=&output=embed"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
